import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CONFIG_TOKEN } from '@core/tokens';

import { TenantSettingsResponse, TenantThemeResponse, TenantsResponse } from './tenant.models';

@Injectable({
  providedIn: 'root',
})
export class TenantService {
  readonly #ROOT_URL = inject(CONFIG_TOKEN).backendRootUrl;

  readonly #httpClient = inject(HttpClient);

  public getTenantTheme$(): Observable<TenantThemeResponse> {
    return this.#httpClient.get<TenantThemeResponse>(`${this.#ROOT_URL}/api/v1/tenant-theme`);
  }

  public getTenants$(): Observable<TenantsResponse> {
    return this.#httpClient.get<TenantsResponse>(`${this.#ROOT_URL}/api/v1/tenants`);
  }

  public getTenantSettings$(): Observable<TenantSettingsResponse> {
    return this.#httpClient.get<TenantSettingsResponse>(`${this.#ROOT_URL}/api/v1/tenant-settings`);
  }
}
